/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.15.0
 * @since 1.0.1
 */

import styled from 'styled-components';

import { ONBOARDING_DATA_ATTR } from '../../../../../../modules/onboarding/onboardingConstants';
import { EOnboardingComponentsId } from '../../../../../../modules/onboarding/types/onboardingTypes';
import { WidgetBlockStyled } from '../../styled/WidgetContainerStyled';
import { IWidgetStyled } from '../../widgetTypes';
import { widgetCostsConfiguration } from '../constant/widgetCostsConstants';

export const WidgetCostsContainerStyled = styled(WidgetBlockStyled).attrs((props: IWidgetStyled) => ({
    className: `widget__widget-cost ${props.isLoading ? 'widget__widget-cost_loading' : ''}`,
    [ONBOARDING_DATA_ATTR]: EOnboardingComponentsId.widgetCost,
}))<IWidgetStyled>`
    min-height: 407px;
    &.widget__widget-cost_loading {
        box-sizing: border-box;
        .widget__widget-skeleton_chart {
            display: flex;
            justify-content: center;
        }
    }
`;

export const WidgetCostsHeaderStyled = styled.div.attrs({
    className: 'widget-cost__header',
})`
    margin-bottom: 32px;
`;

export const WidgetCostsArrowContainerStyled = styled.div.attrs({
    className: 'widget-cost__arrow-container',
})`
    position: absolute;
    left: 0;
    right: 0;
    height: ${widgetCostsConfiguration.chart.size}px;
`;


export const WidgetCostsLinkStyled = styled.div.attrs({
    dataName: 'redirectToPayments',
    className: 'widget-cost__link',
})`
    display: inline-block;
`;

export const WidgetCostsChartStyled = styled.div.attrs({
    className: 'widget-cost__chart',
})`
    min-height: 226px;
    margin-bottom: 24px;
`;
